// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2z8Uj","footer":"ModalError_footer__1EuTn"};